import { html } from 'uhtml';
import FaqListItem from './FaqListItem';

class FaqList {
  constructor(element, context) {
    const _this = this;

    function createToggle(expand) {
      const button = html.node`
        <button class="faq__toggle" onclick=${() => _this.toggleAll(expand)}>
          ${expand ? 'Expand all answers' : 'Collapse all answers'}
        </button>
      `;

      return button;
    }

    element.parentNode.insertBefore(createToggle(true), element);
    element.parentNode.insertBefore(createToggle(false), element);

    const faqElements = Array.from(element.querySelectorAll(':scope > .faq'));
    this.faqs = faqElements.map((e) => new FaqListItem(e, context));

    window.addEventListener('hashchange', () => {
      const matchingFaq = _this.faqs.find(
        (faq) => faq.element && `#${faq.element.id}` === window.location.hash,
      );

      if (matchingFaq) {
        matchingFaq.open(false);
      }
    });
  }

  toggleAll(expand) {
    this.faqs
      .filter((faq) => (expand ? !faq.isOpen() : faq.isOpen()))
      .forEach((faq) => faq.toggle(false));
  }
}

export default FaqList;
